import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import Select from "react-select";
import "../../assets/css/stepper.css";
import { getUserList, getDefaultUserList } from "../../services/Users-services";
import { addRoleUser } from "../../services/Users-services";
import { getOrganizationLevel } from "../../services/OrganisationServices/organizationLevel";
import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../services/system.js";
import { useGlobalState } from "../../services/hostelConst";
import { getLocalStorageData } from "../../services/axiosComponent";
import { closeModal } from "../../services/redux/reducers/modalSlice";
import { useSelector, useDispatch } from "react-redux";
const AddRoleUser = (props) => {
  const refresh = props.refresh;
  console.log(props, "props");

  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  let navigate = props.navigate;

  const [formData, setFormData] = useState({
    // Site Info

    userId: { value: "", label: "", regionId: "", siteId: "" },
  });

  const [loadingUserOptions, setLoadingUserOptions] = useState(false);
  const [loadingGroupLevelOptions, setLoadingGroupLevelOptions] =
    useState(false);

  const [userOptions, setUserOptions] = useState([]);
  const [groupLevelOptions, setGroupLevelOptions] = useState([]);

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  //   const getOrganizationLevelOptions = async (inputValue = null) => {
  //     setLoadingGroupLevelOptions(true);
  //     const res = await getOrganizationLevel({
  //       query: inputValue,
  //       type: "GROUP",
  //       organizationId:
  //         getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
  //     });
  //     if (res.status == "success") {
  //       var list = [];
  //       console.log(res, "res");
  //       res.data.map((item) => {
  //         list.push({
  //           value: item._ID,
  //           label: item["NAME"],
  //         });
  //       });
  //       setGroupLevelOptions(list);
  //     } else {
  //       showErrorMessages({ data: res, navigate });
  //     }
  //     setLoadingGroupLevelOptions(false);
  //   };

  const getUserOptions = async (managerName = null) => {
    setLoadingUserOptions(true);

    const res = await getDefaultUserList({
      query: managerName == "" ? null : managerName,
      type: "ROLE",
      entityId: modal.data["_ID"],
      status: "Y",
    });
    if (res.status == "success") {
      console.log("called");
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
          regionId: item["_REGION"],
          siteId: item["_SITE"],
        });
      });
      setUserOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingUserOptions(false);
  };
  useEffect(() => {
    getUserOptions();

    return () => {};
  }, []);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.userId || !formData.userId.value) {
      newErrors.userId = "User is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      var data = {
        roleId: modal.data._ID,

        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],

        userId: formData.userId.value,
      };

      var res = await addRoleUser(data);
      if (res.status == "success") {
        callToast("success", "Success", "User Added  Successfully");
        await refresh();
        dispatch(closeModal());
      } else {
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
    }
  };

  return (
    <>
      <section className="">
        <div className="d-flex  justify-content-center ">
          <div className="w-100 m-3">
            <div className="d-flex h-100">
              <div className="w-100">
                <>
                  <div className="stepper mb-3 ">
                    <div className="d-flex justify-content-between">
                      <div className={`step active`}>User Info</div>
                    </div>
                  </div>

                  {
                    // Step 1: Site Info
                    <>
                      <div className="row mb-3 m-4 me-2 ms-2">
                        <div className="col-md-12">
                          <label className="form-label">User</label>
                          <Select
                            options={userOptions}
                            value={
                              formData.userId.label === ""
                                ? null
                                : formData.userId
                            }
                            onChange={(value) =>
                              handleChange(
                                "userId",
                                value == null
                                  ? {
                                      value: "",
                                      label: "",
                                      regionId: "",
                                      siteId: "",
                                    }
                                  : value
                              )
                            }
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                height: "100px", // Set dropdown height
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: "100px", // Set max height for the list
                                overflowY: "auto",
                              }),
                            }}
                            placeholder="Select User"
                            isSearchable
                            onInputChange={(inputValue) => {
                              getUserOptions(inputValue);
                            }}
                            noOptionsMessage={() => {
                              return "No User Found";
                            }}
                            components={
                              loadingUserOptions
                                ? {
                                    DropdownIndicator,
                                  }
                                : null
                            }
                            className="basic-single"
                            classNamePrefix="select"
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                          />
                          {errors.userId && (
                            <small className="text-danger">
                              {errors.userId}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-end m-3 mb-0">
                        <Button
                          type="submit"
                          disabled={loading}
                          onClick={handleSubmit}
                        >
                          {loading ? (
                            <div
                              class="spinner-border text-light"
                              role="status"
                            >
                       
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    </>
                  }
                </>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddRoleUser;
